<div class="dashboard-container" *ngIf="isTranslationLoaded">
  <qai-inner-wrap>
    <div class="dashboard-header">
      <h1 class="dashboard-title"> {{'reportingV2.DASHBOARD' | transloco}}</h1>
    </div>

    <ng-container *ngIf="isLoadingAccounts; else content">
      <div class="loading-container">
        <qai-loading size="medium"></qai-loading>
      </div>
    </ng-container>

    <ng-template #content>
      <ng-container *ngIf="accountOptions.length > 0">
        <app-account-team-selector [accountOptions]="accountOptions" [selectedAccount]="selectedAccount"
          [teamOptions]="entityOptions" [selectedTeams]="selectedEntities" [isLoadingAccounts]="isLoadingAccounts"
          [isLoadingTeams]="isLoadingEntities" (accountChange)="onAccountChange($event)"
          (teamChange)="onEntityChange($event)" [multipleCustomers]="multipleCustomers">
        </app-account-team-selector>
      </ng-container>
    </ng-template>
  </qai-inner-wrap>
</div>

<app-dashboard-tabs *ngIf="isTranslationLoaded && accountOptions.length > 0 && !isLoadingAccounts && selectedAccount"
  [selectedAccount]="selectedAccount" [selectedTeams]="selectedEntities" [isTeamAvailable]="isTeamAvailable"
  [isLoading]="isLoadingTeam" [isNetworkCallInprogress]="isNetworkCallInprogress">
</app-dashboard-tabs>